import type { SalarySystemType } from '../enums/SalarySystemType'
import type { SalarySystemSegmentEntity } from './SalarySystemSegmentEntity'
import type { SalarySystemDeliveryType } from '../enums/SalarySystemDeliveryType'

export class CreateUpdateSystemSalaryEntity {
  name?: string | null
  type?: SalarySystemType
  deliveryTypes?: Array<SalarySystemDeliveryType> | null
  perDirectDistance?: {
    amountPerKm?: number
  }
  perRouteDistance?: {
    amountPerKm?: number
  }
  perDirectDistanceSegment?: {
    segments?: Array<SalarySystemSegmentEntity> | null
  }
  perRouteDistanceSegment?: {
    segments?: Array<SalarySystemSegmentEntity> | null
  }
}
